<template>
  <form
    class="p-12 flex flex-wrap justify-center gap-6 items-center bg-black/10 mt-6 relative rounded-3xl overflow-clip"
    @submit.prevent="subscribe"
  >
    <img
      src="/icon.svg"
      class="absolute -bottom-64 -left-32 z-3 w-1/3 h-auto"
    >
    <img
      src="/icon.svg"
      class="absolute -top-12 rotate-90 right-0  z-3 w-1/2  h-auto"
    >
    <transition name="fade">
      <div
        v-if="status === 'sending'"
        class="absolute inset-0 flex items-center justify-center bg-primary-dark/80 z-20"
      >
        <Icon

          name="ri:loader-5-fill"
          class="text-2xl md:text-3xl lg:text-4xl text-primary-green animate-spin"
        />
      </div>
    </transition>
    <input
      v-model="email"
      type="email"
      required
      :disabled="status === 'sending' || status === 'success'"
      placeholder="Enter your email..."
      class="disabled:opacity-50 relative  z-10 rounded-xl px-4 focus:ring-2 focus:outline-0 focus:ring-primary p-2 text-2xl w-full max-w-2xl  bg-white text-primary-dark placeholder-primary-dark focus:placeholder-primary-green"
    >
    <ButtonBasic
      class="z-10"
      :disabled="status === 'sending' || status === 'success'"
    >
      Subscribe
    </ButtonBasic>
    <transition name="fade">
      <div
        v-if="status === 'error'"
        class="w-full z-20"
      >
        <div class="p-3 md:p-6 bg-red-800 rounded-2xl text-lg w-auto mx-auto flex items-center gap-6">
          <Icon
            name="ri:error-warning-fill"
            class="text-xl"
          />
          There was an error subscribing. Please try again later.
        </div>
      </div>
      <div
        v-else-if="status === 'success'"
        class="w-full z-20"
      >
        <div class="p-3  md:p-6 bg-primary-green text-primary-dark rounded-2xl w-auto mx-auto flex items-center gap-6 text-xl">
          <Icon
            name="ri:send-plane-fill"
            class="text-xl"
          />
          You have successfully subscribed to our site!
        </div>
      </div>
    </transition>
  </form>
</template>

<script lang="ts" setup>
const email = ref<string>('')
const status = ref<'' | 'sending' | 'success' | 'error'>('')
async function subscribe() {
  status.value = 'sending'
  try {
    await $fetch('/api/subscribe', {
      method: 'POST',
      body: {
        email: email.value,
      },
    })
    status.value = 'success'
  }
  catch (error) {
    status.value = 'error'
    console.error(error)
  }
  // status.value = 'error'
}
</script>

<style scoped>

</style>
